// Translations for COCON Valouse pages
// /valouse (Valouse.jsx and components)

export const valouseTranslations = {
  // HERO
  hero: {
    subtitle: { fr: "RETRAITE TRANSFORMATRICE", en: "TRANSFORMATIONAL RETREAT" },
    title: { fr: "COCON VALOUSE", en: "COCON VALOUSE" },
    tagline: { fr: "Un espace de passage", en: "A space of passage" },
    location: { fr: "DRÔME PROVENÇALE · FRANCE", en: "DRÔME PROVENÇALE · FRANCE" }
  },

  // PROMISE SECTION
  promise: {
    contextLine: { fr: "La promesse", en: "The promise" },
    title: { fr: "Ce que tu viens chercher", en: "What you are seeking" },
    poeticLine: { fr: "Un espace pour déposer ce qui pèse", en: "A space to release what weighs" }
  },

  // THREE MOVEMENTS SECTION
  threeMovements: {
    contextLine: { fr: "Les trois mouvements", en: "The three movements" },
    title: { fr: "Ancrage · Intégration · Rayonnement", en: "Grounding · Integration · Radiance" },
    poeticLine: { fr: "Trois temps pour une transformation", en: "Three stages for transformation" },
    ancrage: {
      title: { fr: "Ancrage", en: "Grounding" },
      description: { fr: "Revenir au corps. Déposer.", en: "Return to the body. Release." }
    },
    integration: {
      title: { fr: "Intégration", en: "Integration" },
      description: { fr: "Traverser. Accueillir.", en: "Cross through. Welcome." }
    },
    rayonnement: {
      title: { fr: "Rayonnement", en: "Radiance" },
      description: { fr: "Incarner. Repartir autrement.", en: "Embody. Leave transformed." }
    }
  },

  // TRIPTYQUE INTERIOR SECTION
  triptyqueInterior: {
    contextLine: { fr: "Ce qui se vit à l'Intérieur", en: "What is lived within" }
  },

  // INTERIOR SECTION
  interior: {
    contextLine: { fr: "L'expérience vécue", en: "The lived experience" },
    title: { fr: "Ce qui se vit à l'Intérieur", en: "What is lived within" },
    poeticLine: { fr: "Pas de spectateurs. Que des traversées.", en: "No spectators. Only crossings." },
    p1: { fr: "Tu ne regardes pas.", en: "You do not watch." },
    p2: { fr: "Tu participes.", en: "You participate." },
    p3: { fr: "Tu ne consommes pas.", en: "You do not consume." },
    p4: { fr: "Tu traverses.", en: "You cross through." },
    p5: { fr: "Ce qui se transforme ici", en: "What transforms here" },
    p6: { fr: "ne vient pas d'un effort.", en: "doesn't come from effort." },
    p7: { fr: "Mais du cadre,", en: "But from the container," },
    p8: { fr: "du lien,", en: "from connection," },
    p9: { fr: "et de la présence.", en: "and from presence." }
  },

  // CHANGE SECTION
  change: {
    contextLine: { fr: "La transformation", en: "The transformation" },
    title: { fr: "Ce qui change", en: "What changes" },
    stanzas: [
      { fr: "Pas toujours visible.\nMais impossible à ignorer.", en: "Not always visible.\nBut impossible to ignore." },
      { fr: "Tu respires autrement.\n\nPlus lentement.\nPlus profondément.", en: "You breathe differently.\n\nMore slowly.\nMore deeply." },
      { fr: "Quelque chose en toi\ncesse de lutter.", en: "Something in you\nstops fighting." },
      { fr: "Tu ne cherches plus à tenir.\n\nTu habites.", en: "You no longer try to hold on.\n\nYou inhabit." },
      { fr: "Le regard change.\n\nSur toi.\nSur les autres.", en: "The gaze shifts.\n\nToward yourself.\nToward others." },
      { fr: "Et sans effort,\n\nquelque chose s'aligne.", en: "And without effort,\n\nsomething aligns." },
      { fr: "Tu ne repars pas avec une réponse.\n\nTu repars avec une justesse.", en: "You don't leave with an answer.\n\nYou leave with a rightness." },
    ]
  },

  // TESTIMONIALS SECTION
  testimonials: {
    contextLine: { fr: "Paroles vivantes", en: "Living words" },
    title: { fr: "Témoignages", en: "Testimonials" },
    poeticLine: { fr: "Ce que les coconé·e·s ont traversé", en: "What they have crossed" },
    intro: { 
      fr: "Peut-être as-tu déjà entendu parler de COCON.<br />Voici leurs mots.",
      en: "Perhaps you have already heard of COCON.<br />Here are their words."
    },
    quotes: [
      { text: { fr: "Je suis venue en crabe. Et je repars en paix.", en: "I arrived guarded. And I leave at peace." }, author: "André" },
      { text: { fr: "J'ai trouvé des réponses. Et surtout du lien.", en: "I found answers. And above all, connection." }, author: "Estelle" },
      { text: { fr: "J'ai pu tomber le gilet pare-balles. Et aimer.", en: "I could let down my armor. And love." }, author: "Mélissa" },
      { text: { fr: "Je ne savais pas que j'en avais autant besoin…", en: "I didn't know I needed it so much…" }, author: "Lydie" },
      { text: { fr: "Ce que j'ai vécu ici, je ne pourrais pas l'expliquer…", en: "What I experienced here, I couldn't explain…" }, author: "Valérie" }
    ],
    button: { fr: "Je laisse ces mots me traverser", en: "I let these words pass through me" }
  },

  // ENGAGEMENT SECTION
  engagement: {
    contextLine: { fr: "Le passage", en: "The passage" },
    title: { fr: "Engagement", en: "Commitment" },
    poeticLine: { 
      fr: "COCON n'a jamais été conçu pour séduire.<br />Il a été pensé comme un seuil.",
      en: "COCON was never meant to convince.<br />It was designed as a threshold."
    },
    cycle: {
      title: { fr: "COCON est un cycle.", en: "COCON is a cycle." },
      subtitle: { fr: "Un cycle initiatique contemporain.", en: "A contemporary initiatory cycle." },
      description: { fr: "Structuré. Tenu. Incarné.", en: "Structured. Held. Embodied." },
      timing: { fr: "Avant. Pendant. Après.", en: "Before. During. After." }
    },
    preCocon: {
      title: { fr: "Avant — Pré-COCON", en: "Before — Pre-COCON" },
      p1: { fr: "5 semaines.", en: "5 weeks." },
      p2: { fr: "5 rendez-vous.", en: "5 gatherings." },
      p3: { fr: "Un lien réel avant l'arrivée.", en: "A real connection before arrival." }
    },
    pendant: {
      title: { fr: "Pendant — L'immersion", en: "During — The immersion" },
      p1: { fr: "5 jours à Valouse.", en: "5 days at Valouse." },
      p2: { fr: "Un Hameau entièrement privatisé.", en: "A fully privatized hamlet." },
      p3: { fr: "Un cercle limité.", en: "A limited circle." }
    },
    postCocon: {
      title: { fr: "Après — Post-COCON", en: "After — Post-COCON" },
      p1: { fr: "5 semaines.", en: "5 weeks." },
      p2: { fr: "5 rendez-vous.", en: "5 gatherings." },
      p3: { fr: "Une intégration tenue.", en: "A supported integration." }
    },
    closingLine: { 
      fr: "L'immersion n'est pas un événement isolé.<br />C'est le centre d'un processus.",
      en: "The immersion is not an isolated event.<br />It is the center of a process."
    },
    scarcity: {
      p1: { fr: "20 places uniquement.", en: "20 places only." },
      p2: { fr: "Un Hameau entièrement privatisé.", en: "A fully privatized hamlet." },
      p3: { fr: "Un cercle à taille humaine.", en: "A human-scale circle." },
      note: { 
        fr: "Ce format est volontairement limité pour préserver la qualité du lien,<br />la profondeur du travail,<br />et l'attention réelle portée à chaque participant·e.",
        en: "This format is intentionally limited to preserve the quality of connection,<br />the depth of the work,<br />and the genuine attention given to each participant."
      }
    }
  },

  // INSIDE COCON SECTION
  insideCocon: {
    contextLine: { fr: "L'essence de COCON", en: "The essence of COCON" },
    title: { fr: "Ce qui se vit à l'intérieur du COCON", en: "What is lived inside the COCON" },
    poeticLine: { fr: "Une expérience qui se vit, non qui se raconte", en: "An experience to be lived, not told" },
    p1: { fr: "COCON n'est pas une idée.", en: "COCON is not an idea." },
    p2: { 
      fr: "C'est une expérience vécue,<br />dans le corps, dans le lien, dans le quotidien partagé.",
      en: "It is a lived experience,<br />in the body, in connection, in shared daily life."
    },
    p3: { fr: "Si tu veux sentir comment se vit réellement le voyage,", en: "If you want to feel how the journey is truly lived," },
    p4: { fr: "ce qui s'y traverse, ce qui s'y partage, ce qui s'y transforme,", en: "what is crossed, what is shared, what is transformed," },
    p5: { fr: "et ce que l'on en ramène…", en: "and what one brings back…" },
    button: { fr: "Découvrir l'expérience COCON", en: "Discover the COCON experience" },
    crossLink: {
      label: { fr: "Découvrir l'autre traversée", en: "Discover the other journey" },
      linkText: { fr: "COCON SACRÉ 2026 · Bali & Java", en: "COCON SACRÉ 2026 · Bali & Java" }
    }
  },

  // CIRCLE SECTION
  circle: {
    contextLine: { fr: "Le cercle", en: "The circle" },
    title: { fr: "COCONEUSES", en: "COCONEUSES" },
    poeticLine: { fr: "Celles qui accompagnent la traversée", en: "Those who guide the crossing" },
    maxSouls: { fr: "20 âmes maximum.", en: "20 souls maximum." },
    preserveIntro: { fr: "Pour préserver :", en: "To preserve:" },
    preserveItems: [
      { fr: "la profondeur du travail.", en: "the depth of the work." },
      { fr: "La sécurité émotionnelle.", en: "Emotional safety." },
      { fr: "La qualité du lien.", en: "The quality of connection." }
    ],
    circleIntro: { fr: "Un cercle.", en: "A circle." },
    circleNotAddition: { fr: "Pas une addition de pratiques.", en: "Not an addition of practices." },
    womenCount: { fr: "7 femmes.", en: "7 women." },
    womenPresent: { fr: "Présentes.", en: "Present." },
    womenAnchored: { fr: "Ancrées.", en: "Anchored." },
    womenComplementary: { fr: "Complémentaires.", en: "Complementary." },
    weaveLine1: { fr: "Et quelque chose qui se tisse entre elles.", en: "And something that weaves between them." },
    weaveLine2: { fr: "Et avec toi.", en: "And with you." },
    discoverButton: { fr: "Je ressens le cercle", en: "I feel the circle" }
  },

  // PLACE SECTION
  place: {
    contextLine: { fr: "Le Hameau", en: "The hamlet" },
    title: { fr: "VALOUSE", en: "VALOUSE" },
    poeticLine: { fr: "Un village privatisé pour la traversée", en: "A privatized village for the crossing" },
    village16th: { fr: "Un village en pierre du XVIe siècle.", en: "A 16th-century stone village." },
    privatized: { fr: "Privatisé intégralement pour COCON.", en: "Entirely privatized for COCON." },
    stats: {
      ares: { fr: "ares", en: "ares" },
      pools: { fr: "piscines", en: "pools" },
      rooms: { fr: "chambres", en: "rooms" }
    },
    pillar: { fr: "Ici, le cadre n'est pas un décor. Il est un pilier.", en: "Here, the setting is not a backdrop. It is a pillar." },
    learnMore: { fr: "En savoir plus sur le lieu", en: "Learn more about the place" },
    details: {
      p1: { fr: "Le Hameau de Valouse n'est pas un simple domaine. C'est un village du XVIe siècle, entièrement privatisé.", en: "The Hamlet of Valouse is not just an estate. It's a 16th-century village, entirely privatized." },
      p2: { fr: "Soixante ares de silence. Des ruelles en pierre. Trois piscines. Trente-neuf chambres rénovées. Toutes avec salle de bain privative.", en: "Sixty ares of silence. Stone alleys. Three pools. Thirty-nine renovated rooms. All with private bathroom." },
      p3: { fr: "Ici, personne d'extérieur ne circule. Aucune cohabitation. Aucun bruit parasite.", en: "Here, no outsiders come through. No cohabitation. No parasitic noise." },
      p4: { fr: "Quand tu entres dans le COCON, tu entres dans un espace fermé au monde.", en: "When you enter the COCON, you enter a space closed to the world." },
      p5: { fr: "Tu dors sur place. Tu vis sur place. Tu traverses sur place.", en: "You sleep on site. You live on site. You cross on site." },
      p6: { fr: "Le lieu devient contenant.", en: "The place becomes container." }
    }
  },

  // FORMULAS SECTION
  formulas: {
    contextLine: { fr: "Les formules", en: "The formulas" },
    title: { fr: "Choisir sa traversée", en: "Choose your crossing" },
    poeticLine: { fr: "Trois chemins, une même destination", en: "Three paths, one destination" },
    integralCycle: {
      label: { fr: "Expérience complète", en: "Complete experience" },
      title: { fr: "Cycle Initiatique Intégral", en: "Full Initiatory Cycle" },
      timing: { fr: "Avant · Pendant · Après", en: "Before · During · After" },
      price: "1 888 € TTC",
      installments: { fr: "Jusqu'à 9 mensualités sans frais", en: "Up to 9 interest-free installments" },
      button: { fr: "Cycle Intégral", en: "Full Cycle" }
    },
    centralCrossing: {
      label: { fr: "Immersion — Valouse", en: "Immersion — Valouse" },
      title: { fr: "La Traversée Centrale", en: "The Central Crossing" },
      duration: { fr: "5 jours · 4 nuits", en: "5 days · 4 nights" },
      price: "1 488 € TTC",
      note: { fr: "Le cœur du cycle", en: "The heart of the cycle" },
      button: { fr: "La Traversée", en: "The Crossing" }
    },
    accompaniments: {
      label: { fr: "Modules complémentaires", en: "Additional modules" },
      title: { fr: "Accompagnements", en: "Accompaniments" },
      timing: { fr: "Pré-COCON ou Post-COCON", en: "Pre-COCON or Post-COCON" },
      price: { fr: "200 € / module", en: "200 € / module" },
      note: { fr: "À ajouter à la Traversée", en: "Add to the Crossing" },
      preCocon: { fr: "Pré-COCON", en: "Pre-COCON" },
      postCocon: { fr: "Post-COCON", en: "Post-COCON" }
    }
  },

  // FAQ SECTION
  faq: {
    contextLine: { fr: "Questions fréquentes", en: "Frequently asked questions" },
    title: { fr: "FAQ", en: "FAQ" },
    poeticLine: { fr: "Ce que tu as besoin de savoir", en: "What you need to know" }
  },

  // FINAL CTA
  finalCta: {
    intro: { 
      fr: "Si quelque chose en toi reconnaît cet appel,<br />la traversée peut commencer ici.",
      en: "If something within you recognizes this call,<br />the crossing can begin here."
    },
    button: { fr: "Je rejoins le cercle", en: "Je rejoins le cercle" },
    socialProof: { 
      fr: "",
      en: ""
    }
  },

  // MIRROR SECTION (final CTA transition)
  mirror: {
    line1: { fr: "Alors écoute simplement.", en: "Then simply listen." },
    line2: { fr: "Si en lisant ces lignes", en: "If in reading these lines" },
    line3: { fr: "quelque chose en toi s'ouvre,", en: "something within you opens," },
    line4: { fr: "si une partie de toi reconnaît ce passage.", en: "if a part of you recognizes this passage." },
    line5: { fr: "alors peut-être que ce cercle", en: "then perhaps this circle" },
    line6: { fr: "t'attend déjà.", en: "is already waiting for you." }
  },

  // NEWSLETTER
  newsletter: {
    title: { fr: "RESTONS RELIÉ·E·S", en: "LET'S STAY CONNECTED" },
    description: { 
      fr: "Pour recevoir les lettres du COCON,<br />ou nous retrouver en ligne.",
      en: "To receive letters from COCON,<br />or find us online."
    },
    placeholder: { fr: "Ton email", en: "Your email" },
    button: { fr: "Newsletter", en: "Subscribe" }
  }
};

export default valouseTranslations;
